import * as wjcSheet from '@grapecity/wijmo.grid.sheet';

import { FlexSheetValueConverter } from '../flex-sheet-value-converter';
import { enumValuesToArray } from '../../../_utils/enum-values-to-array';
import { NumberToSimulationVariableMapper } from '../mappers/number-to-simulation-variable-mapper';
import { MineSourceCellConfig, MineSourceSheetRows } from '../cell-config/mine-source-cell-config';
import { MineSourceFlexSheetMapper } from '../mappers/mine-source-flex-sheet-mapper';
import { MineSource } from '../../../_models/_unit-operations/mine-source';
import { UnitOperationFlexSheetEventHandler } from './unit-operation-flex-sheet-event-handler';

export class MineSourceFlexSheetEventHandler implements UnitOperationFlexSheetEventHandler {
  constructor(private valueConverter: FlexSheetValueConverter) {}

  handle(unitOperation: MineSource, spreadsheet: wjcSheet.FlexSheet, flexSheetEvent, rawValue) {
    const { row } = flexSheetEvent;

    if (enumValuesToArray(MineSourceSheetRows).indexOf(row) === -1) {
      flexSheetEvent.cancel = true;
      return;
    }

    const cellConfig = MineSourceCellConfig.find(rowConfig => rowConfig.row === row);
    const convertedValue = this.valueConverter.convert(spreadsheet, rawValue, cellConfig);

    const simulationVariableMapper = new NumberToSimulationVariableMapper();
    const mapper = new MineSourceFlexSheetMapper(simulationVariableMapper);

    mapper.map(unitOperation, row, convertedValue);
  }
}
